/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import Topbar from "../../../components/Topbar/Topbar";
import { drag, edit_icon, Search_icon, view_icon } from "../../../assets/img";
import { get, patch, post, put } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";
import { checkPermission } from "../../redux/api/PermissionManager";

const TimeSlot = () => {
  const [list, setList] = useState([]);
  const [label, setLabel] = useState("Room Booking");
  const [addPopup, setAddPopup] = useState(false);
  const [type, setType] = useState();
  const [errors, setErrors] = useState(false);
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState("");
  const [timeId, setTimeId] = useState();
  const [formData, setFormData] = useState({
    timeslot_name: "",
    display_name: "",
    timeslot_type: "",
    start_time: "",
    end_time: "",
    service_type: "",
    description: "",
    duration: "",
  });

  //save reference for dragItem and dragOverItem
  const dragItem = React.useRef(null);
  const dragOverItem = React.useRef(null);

  //const handle drag sorting
  const handleSort = () => {
    //duplicate items
    let navigateItems = [...list];

    //remove and save the dragged item content
    const draggedItemContent = navigateItems.splice(dragItem.current, 1)[0];

    //switch the position
    navigateItems.splice(dragOverItem.current, 0, draggedItemContent);

    //reset the position ref
    dragItem.current = null;
    dragOverItem.current = null;

    //update the actual array
    setList(navigateItems);
    setShow(true);
  };

  const fetch = async () => {
    const url = search
      ? `${URLS.TIMESLOT}?search=${search}`
      : `${URLS.TIMESLOT}`;

    try {
      const res = await get(url);
      setList(res?.results || res?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetch();
  }, [search]);

  const handleSubmit = async () => {
    if (!formData.display_name) {
      toast.error("Please enter Display name");
      return;
    }
    const res = await put(`${URLS.TIMESLOT}${timeId}/edit/`, {
      display_name: formData.display_name,
    });
    if (res?.status === "success") {
      toast.success(res?.message || "Updated successfully");
      setAddPopup(false);
      fetch();
      setErrors(false);
      setAddPopup(false);
    }
  };

  const savePosition = async () => {
    try {
      const payload = list.map((item, index) => ({
        id: item.id,
        position: index + 1,
      }));

      const res = await post(`${URLS.TIMESLOT}positions/`, payload);

      if (res?.status === "success") {
        toast.success(res?.message || "Position updated");
        setShow(false);
        fetch();
      }
    } catch (err) {
      toast.error("Failed to save positions");
      console.error(err);
    }
  };

  // ✅ Toggle status
  const handleStatus = async (id, status) => {
    // const payload = new FormData();
    const value = {
      status: status === 1 ? 2 : 1,
    };
    // payload.append();

    const res = await patch(URLS.TIMESLOT + id + "/status/", value);
    console.log("property status", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      fetch();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div>
      <Topbar header={"Master"} subHead={"Time Slot"} />

      <div className="d-flex ac-jf">
        <div>
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mb-4">
            Total: {list?.length}
          </h2>
          <div className="d-flex gap-3">
            {["Room Booking", "Get Together"].map((ele) => {
              const isDisabled = ele === "Get Together"; // disable condition

              return (
                <div
                  key={ele}
                  style={{
                    background:
                      label === ele && !isDisabled ? "#6B00D8" : "none",
                    color: isDisabled
                      ? "#ccc" // disabled color
                      : label === ele
                        ? "#fff"
                        : "#898989",
                    padding: "10px 16px",
                    borderRadius: 9,
                    fontSize: "16px",
                    fontWeight: 700,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.6 : 1,
                    pointerEvents: isDisabled ? "none" : "auto", // prevent clicking
                  }}
                  onClick={() => !isDisabled && setLabel(ele)}
                >
                  {ele}
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex gap-3">
          {show && (
            <button
              onClick={savePosition}
              className="submit-btn f2"
              style={{ minWidth: "120px" }}
            >
              {/* {loading ? "Loading..." : "Confirm"} */}Save
            </button>
          )}
          <div className="search-input">
            <input
              type="text"
              placeholder="Search"
              style={{ border: "none", width: 150 }}
              onChange={(e) => setSearch(e.target.value)}
            />
            <img src={Search_icon} className="search" alt="" />
          </div>
        </div>
      </div>
      <div className="mt-5" style={{ width: "100%", overflow: "auto" }}>
        <table
          className="table-design-new"
          style={{ width: "98%", borderRadius: "10px" }}
        >
          <thead>
            <tr className="border-bottom w-100">
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  S.No
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Slot Name
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Display Name
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Slot Hrs
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Start Time
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  End Time
                </p>
              </th>
              {/* <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Description
                </p>
              </th>
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Service Type
                </p>
              </th> */}
              <th>
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Status
                </p>
              </th>
              <th>
                {" "}
                <p className="f-w600  fs-sm-10 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  py-2 gray3 d-flex ac-js p-2">
                  Action
                </p>
              </th>
            </tr>
          </thead>
          <tbody>
            {/* {Array.isArray(dummiData) &&
              dummiData?.map((item, index) => { */}
            {list?.map((item, index) => {
              // let src = item?.image !=='' ? URL.createObjectURL(item?.image) : item?.image;
              return (
                <tr
                  key={index}
                  className="list-item p-2"
                  // draggable
                  onDragStart={(e) => (dragItem.current = index)}
                  onDragEnter={(e) => (dragOverItem.current = index)}
                  onDragEnd={handleSort}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 red list-data d-flex ac-js">
                      {index + 1}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.timeslot_type}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.display_name}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.duration}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.start_time}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.end_time}
                    </p>
                  </td>
                  {/* <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.description}
                    </p>
                  </td>
                  <td>
                    <p className="pointerView f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-15 fs-xxl-16 px-3 py-2 mt-2 gray2 list-data d-flex ac-js">
                      {item?.service_type}
                    </p>
                  </td> */}
                  <td>
                    <button
                      onClick={() => {
                        if (checkPermission("CAN-STATUS-TIME_SLOT"))
                          handleStatus(item?.id, item?.status);
                      }}
                      className={`${
                        item?.status === 2 ? "deactive-btn" : "active-btn"
                      } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13 fs-xxl-18 p-2`}
                    >
                      {item?.status === 2 ? "De-active" : "Active"}
                    </button>
                  </td>
                  <td>
                    <div className="d-flex ac-js sec p-2">
                      {checkPermission("CAN-VIEW-TIME_SLOT") && (
                        <button
                          onClick={() => {
                            setAddPopup(true);
                            setType("view");
                            setFormData(item);
                            // fetchDetails(item?.id);
                            setTimeId(item?.id);
                          }}
                          className="cust-btn"
                        >
                          <img src={view_icon} alt="" className="edit-btn" />
                        </button>
                      )}

                      {checkPermission("CAN-EDIT-TIME_SLOT") && (
                        <button
                          onClick={() => {
                            setAddPopup(true);
                            setType("edit");
                            setFormData(item);
                            // fetchDetails(item?.id);
                            setTimeId(item?.id);
                          }}
                          className="cust-btn ms-3"
                        >
                          <img src={edit_icon} alt="" className="edit-btn" />
                        </button>
                      )}
                    </div>
                  </td>
                  <td className="position-relative">
                    <div className="drag-box">
                      <img src={drag} className="drag-img" alt="" />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
                View List
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                  setErrors("");
                }}
                className="pointer"
              />
            </div>
            <div className="w-100 mt-3">
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-1 text-start">
                Slot Name
              </p>
              <input
                className="input-box"
                name="timeslot_name"
                value={formData.timeslot_name}
                readOnly
                onChange={handleChange}
                type="text"
                placeholder="Day Regulars"
              />

              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-1 text-start">
                Display Name{" "}
                <span style={{ color: "#adadad", fontSize: 12 }}>
                  Character limit: 10 (to prevent design issues).
                </span>
              </p>
              <input
                className="input-box"
                name="display_name"
                value={formData.display_name}
                readOnly={type !== "edit"}
                onChange={handleChange}
                type="text"
                placeholder="display name"
              />
              {errors && <p className="err text-start">Enter Display Name</p>}
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                Slot Hrs
              </p>
              <input
                className="input-box"
                name="userName"
                readOnly
                onChange={handleChange}
                type="text"
                placeholder="Slot Regulars"
                value={formData?.duration}
                disabled
              />
              {errors.duration && <p className="err">{errors.duration}</p>}
              <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                Service Type
              </p>
              <input
                className="input-box"
                name="userName"
                readOnly
                onChange={handleChange}
                type="text"
                placeholder="Slot Regulars"
                disabled
                value={formData?.service_type}
              />
              {errors.userName && <p className="err">{errors.userName}</p>}
              {/* <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-3 text-start">
                Description
              </p>
              <input
                className="input-box"
                name="userName"
                readOnly
                onChange={handleChange}
                type="text"
                placeholder="Slot Regulars"
                disabled
                value={formData?.description}
              />
              {errors.userName && <p className="err">{errors.userName}</p>} */}
              <div className="d-flex mt-3 gap-3">
                <div className="">
                  <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 text-start">
                    {" "}
                    Start Time
                  </p>
                  <input
                    type="time"
                    value={formData?.start_time}
                    readOnly
                    className="input-box readonly-like"
                    placeholder="From Date"
                  />
                </div>
                <div className="">
                  <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 text-start">
                    {" "}
                    End Time
                  </p>
                  <input
                    type="time"
                    value={formData?.end_time}
                    readOnly
                    className="input-box readonly-like"
                    placeholder="To Date"
                  />
                </div>
              </div>
            </div>

            {type === "edit" && (
              <div className="d-flex ac-jb px-2 mt-5">
                <button
                  onClick={() => {
                    setAddPopup(false);
                    setErrors("");
                    // logout();
                  }}
                  className="back-btn f2 w-40"
                >
                  {/* {loading ? "Loading..." : "Confirm"} */}Cancel
                </button>

                <button
                  onClick={() => {
                    handleSubmit();
                  }}
                  className="submit-btn f2 w-40"
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TimeSlot;
